import { createSvgIcon } from '@mui/material/utils'

const ArrowRight = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.79289 1.50008L10.2929 4.00008H0V5.00008H10.2929L7.79289 7.50008L8.5 8.20718L11.5 5.20718L12.2071 4.50008L11.5 3.79297L8.5 0.792969L7.79289 1.50008Z"
      fill="black"
    />
  </>,
  'ArrowRight'
)

export default ArrowRight
